import React, { useContext } from 'react'
import { SectionHeader, Header2, Text } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import GiftCardContext from './GiftCardContext'

// eslint-disable-next-line
const ChooseGift = () => {
  const {
    state: { giftOption },
    dispatch,
  } = useContext(GiftCardContext)

  const chooseGift = (option) => {
    dispatch({ type: 'SET_GIFT_OPTION', option })
  }

  return (
    <div className="gift-card-choose-product" id="main-content" tabIndex="0">
      <SectionHeader margin="0 0 9px 0" small>
        step 1
      </SectionHeader>
      <Header2 margin="0 0 35px 0">Choose a gift</Header2>
      <div className="gift-card-options">
        <button
          className={giftOption && giftOption === 'gift-card' ? 'selected' : ''}
          title="gift-card-button"
          id="gift-card-option"
          onClick={() => chooseGift('gift-card')}
        >
          <Header2 fontSize="28px" margin="0 0 5px 0">
            Gift Cards
          </Header2>
          <Text
            color={gsColors.meredithGrey}
            fontSize={18}
            lineHeight="145%"
            spacing={0.18}
          >
            Let them choose their gift
          </Text>
        </button>
        <button
          className={giftOption && giftOption === 'package' ? 'selected' : ''}
          title="gift-package-button"
          id="gift-package-option"
          onClick={() => chooseGift('package')}
        >
          <Header2 fontSize="24px" margin="0 0 5px 0">
            Package
          </Header2>
          <Text
            color={gsColors.meredithGrey}
            fontSize={18}
            lineHeight="145%"
            spacing={0.18}
          >
            For hair, makeup, nails
          </Text>
        </button>
      </div>
      <div className="divider" />
    </div>
  )
}

export default ChooseGift
